import { createContext } from "react";

export const CompanyContext = createContext(null);